/* @flow */
import React from 'react';
import { IndexRoute, Route } from 'react-router';

import SetupAdminRole from './components/SetupAdminRole.jsx';
import SetupDefaultView from './components/SetupDefaultView.jsx';
import SetupFullName from './components/SetupFullName.jsx';
import SetupGroup from './components/SetupGroup.jsx';
import SetupSchool from './components/SetupSchool.jsx';
import SetupView from './components/SetupView.jsx';
import SetupSmsDevice from './components/SetupSmsDevice.jsx';
import SetupSignature from './components/SetupSignature.jsx';
import SetupEmail from './components/SetupEmail.jsx';
import SetupPassword from './components/SetupPassword.jsx';
import SetupSubscription from './components/SetupSubscription.jsx';
import SetupSchoolEmail from './components/SetupSchoolEmail.jsx';

export default (
  <Route path="/setup(/)" component={SetupView} onEnter={SetupView.onEnter}>
    <Route path="/setup/class" component={SetupGroup} />
    <Route path="/setup/school" component={SetupSchool} />
    <Route path="/setup/signature" component={SetupSignature} onEnter={SetupSignature.onEnter} />
    <Route path="/setup/name" component={SetupFullName} onEnter={SetupFullName.onEnter} />
    <Route path="/setup/device/sms" component={SetupSmsDevice} onEnter={SetupSmsDevice.onEnter} />
    <Route
      path="/setup/subscriptions"
      component={SetupSubscription}
      onEnter={SetupSubscription.onEnter}
    />
    <Route path="/setup/password" component={SetupPassword} />
    <Route path="/setup/email" component={SetupEmail} onEnter={SetupEmail.onEnter} />
    <Route path="/setup/admin_role" component={SetupAdminRole} onEnter={SetupAdminRole.onEnter} />
    <Route path="/setup/school_email" component={SetupSchoolEmail} />

    <IndexRoute component={SetupDefaultView} onEnter={SetupDefaultView.onEnter} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/setup/routes.js